<span *ngFor="let button of buttonConfigs" class="button-and-badge">
  <ion-button
    [class.hidden]="button.hide"
    [attr.data-testid]="button.icon"
    (click)="button.handler($event)"
    [disabled]="button.isDisabled"
    [ngClass]="{ 'route-button': button === routeButtonConfig }"
    class="action-button"
    fill="clear"
    [matTooltip]="button.tooltip | translate">
    <ion-icon *ngIf="button.icon" slot="icon-only" [name]="button.icon"></ion-icon>
    <ion-icon *ngIf="!button.icon" slot="icon-only" [src]="button.iconUrl"></ion-icon>
  </ion-button>
  <ng-container *ngIf="button.badge$ | async as badge">
    <div *ngIf="badge > 0" class="badge">{{ badge }}</div>
  </ng-container>
</span>
<span class="alc-spacer"></span>
<span *ngIf="shouldShowBackButton" class="button-and-badge">
  <ion-button
    data-testid="complete-and-release"
    (click)="onReleaseAndBackClicked($event)"
    class="action-button"
    fill="clear"
    [matTooltip]="'m/task-process/tooltips/go_back' | translate">
    <ion-icon slot="icon-only" name="close-circle"></ion-icon>
  </ion-button>
</span>
<!-- hidden tag select that will be triggered to select a team -->
<app-select-tag
  *ngIf="routingTagGroup"
  #selectRoutingTag
  [group]="routingTagGroup"
  [tagsContext]="tagsContext"></app-select-tag>

<button
  *ngIf="showSendByEmailReopenButton"
  mat-raised-button
  color="primary"
  (click)="reOpenSendByEmailPopover()"
  #sendByEmailReOpenButton
  class="hidden send-by-email-reopen-button">
  <mat-icon>zoom_out_map</mat-icon>
  <span translate="m/task-process/tooltips/send-by-email"></span>
</button>
